<mat-form-field *ngIf='field ' appearance="outline" [style.width]="field.matFormFieldWidth" [formGroup]="group">

    <input type="text" [placeholder]="field.placeHolder" aria-label="Number" matInput [formControlName]="field.name"
        [formControl]="myControl" [matAutocomplete]="auto" (input)="onInput($event)" (keyup)="onKeyup(field.name, $event, field.select.options)"
        [(ngModel)]='inputValue'>

    <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredOptions" [value]="option.name" (click)="selected(field.name, option)">
            {{option.name}}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>